<template>
  <div>
    <ion-searchbar
      no-border
      v-ion-model="keywords"
      :debounce="600"
      @ionChange="search"
    ></ion-searchbar>

    <ion-item v-if="!keywords  || keywords.trim() == ''">
      <ion-label class="search-label">
        Recent Searches
      </ion-label>
    </ion-item>

    <ion-list v-if="!keywords || keywords.trim() == ''">
        <ion-item @click="recentClick(key)" button v-for="(key, idx) in recentItems" :key="idx">
            {{key}}
        </ion-item>
    </ion-list>

    <div v-if="onSearch" class="search-spinner">
      <ion-spinner></ion-spinner>
    </div>

    <ion-list>
      <ion-item v-if="count >= 0 && keywords.trim() && !onSearch"
        >{{ count }} match<span v-if="count > 1">es</span>&nbsp;found.</ion-item
      >
      <ion-item
        detail
        button
        v-for="(c, idx) in result"
        :key="idx"
        :href="`#/laws/${c.lawid}`"
      >
        <ion-grid when="sm" style="width:100%">
          <ion-row>
            <ion-col size-sm="3" size="12"
              ><p class="no-margin">{{ c.ref }}</p></ion-col
            >

            <ion-col size-sm="7" size="12">
              <h2 class="list-title" v-html="c.shortTitle"></h2>
            </ion-col>

            <ion-col size-sm="2" size="12"
              ><span>{{ formatDate(c.date) }}</span></ion-col
            >
          </ion-row>
        </ion-grid>
      </ion-item>
    </ion-list>

    <ion-infinite-scroll
      ref="scoller"
      threshold="200px"
      @ionInfinite="loadNext"
    >
      <ion-infinite-scroll-content
        loadingSpinner="bubbles"
        loadingText="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
</template>
<script>
import debounce from "debounce";
import { format } from "date-fns";

export default {
  data() {
    return {
      result: [],
      page: 0,
      keywords: "",
      count: 0,
      limits: 0,
      offset: 0,
      pages: 0,
      onSearch: false
    };
  },

  computed: {
    recentItems() {
      const items = this.$store.state.history.search.laws.slice().reverse();
      return items.slice(0, 8);
    }
  },

  methods: {
    async _search(append = false) {

      if(this.keywords.trim() == "") {
        this.result = [];
        return;
      }

      this.onSearch = true;

      if (!append) {
        this.page = 0;
      }

      var params = {
        q: this.keywords.trim() || "",
        p: this.page
      };

      var res = await this.$lawyerly.laws.search(params);

      this.count = res.data.count;

      if (append) {
        if(res.data.result) {
          this.result = [...this.result, ...res.data.result];
        }
      } else {
        this.result = res.data.result;
      }

      this.limits = res.data.limits;
      this.offset = res.data.offset;
      this.pages = this.count / (this.limits || 1);
      this.$refs.scoller.disabled = this.page >= this.pages;
      this.$store.commit("ui/setLastLawQuery", this.keywords);
      if(res.data.count > 0) {
        this.$store.commit("history/addSearch", {key: this.keywords, type: "laws"});
      }

      setTimeout(()=>{
        this.onSearch = false;
      }, 300);
    },

    async loadNext(evt) {
      this.page = this.page + 1;
      await this._search(true);
      evt.target.complete();
    },

    search: debounce(function() {
      this._search();
    }, 500),

    recentClick(keyword){
    this.keywords = keyword;
    },

    formatDate(date) {
      return format(new Date(date), "MMM-dd-yyyy");
    }
  },

  mounted() {
    this.$store.commit("ui/setHeaderTitle", "Search Laws");
    this.keywords = this.$store.state.ui.lastLawQuery;
    if(this.keywords) {
      this._search({ q: this.keywords });
    }
  },

  beforeDestroy() {
    this.$store.commit("ui/setHeaderTitle", "");
  }
};
</script>
<style>
h2.list-title {
  font-size: 14pt;
  margin: 0px;
}
b.hi {
  background-color: rgba(255, 255, 0, 0.2);
}

.search-label {
  font-size: 0.85em !important;
}
</style>
